import type { IAddress } from "@bbj-types/address";
import { Stack, type StackProps } from "@mui/material";
import { Address } from "@styleguide";
import type React from "react";
import { useModalOfferContext } from "../context";

export const AddressInput = (props: StackProps) => {
  const { offer, setOffer, errors, setErrors, disabled, applyFollowUp, createOffer } = useModalOfferContext();
  const required = !applyFollowUp || createOffer;
  return (
    <Stack {...props}>
      <Address
        id="offer-address-input"
        label="Adresse"
        value={offer.address || null}
        onChange={(_: React.SyntheticEvent<Element, Event>, address: IAddress | null) => {
          setOffer((offer) => ({ ...offer, address: address || undefined }));
          if (address) {
            setErrors((errors) => ({ ...errors, address: false }));
          }
        }}
        size="small"
        disabled={disabled}
        TextFieldProps={{ error: errors.address || false, disabled, required: required }}
      />
    </Stack>
  );
};
